export class Contacto {
    nombre: string;
    apellidoPaterno: string;
    apelldioMaterno: string;
    correoElectronico: string;
    numeroTelefonicoI: string;
    numeroTelefonicoII: string;
    comentario: string;
}


// WEBPACK FOOTER //
// ./src/app/models/contacto.ts